module.exports = __webpack_public_path__ + "img/lingshi.2a46942b.png";